export default "__VITE_ASSET__CZLTGHKd__"